import React from 'react';

export default class Intro extends React.Component {
  render() {
    return <div className="content">
      <h3 className="title is-3">Introduction</h3>
      <p>Welcome to the CCI API documentation.  This API will give you the ability to request scale data, patients, visit configurations, update visits and post patient responses to scale data.</p>

      <h3 className="subtitle">Making Requests</h3>

      <p>All requests should supply the <code>Accept: application/json</code> header. Post requests must specify the <code>Content-Type: application/json</code> header.  Request and response bodies are json encoded.</p>
      <p>Requests must be made over HTTPS. Any non-secure requests are met with a redirect (HTTP 302) to the HTTPS equivalent URI.</p>

      <h3 className="subtitle">Authorization</h3>
      <p>All requests require an OAuth access token or a client id and client secret. OAuth access tokens are passed via the <code>Authorization</code> header:</p>
      <p><code>Authorization: Bearer {`{access_token_here}`}</code></p>
      <p>Requests that require a client id and client secret must be passed via the <code> Authorization</code> header:</p>
      <p><code>Authorization: Basic {`{base64_encode({client_id}:{client_secret})}`}</code></p>
      <p>Client credentials requests must also include the <code>Content-Type</code> header set to <code>application/x-www-form-urlencoded</code> and include the following additional payload:</p>
      <div className="code-snippet">
<pre><code>{`{
  grant_type: 'client_credentials'
}`}</code></pre>
      </div>
      <p style={{ marginTop: '10px' }}>OAuth token requests that use <code>grant_type: client_credentials</code> always return the following base values:</p>
      <p><em>Client credentials associated to applications with clinician owners include additional properties described in the "Clinicians" section.</em></p>
      <div className="code-snippet">
<pre><code>
{`{
  access_token: "e5228019f1fc36e82fbea2f787ae50be5acb00352205aed181c323be1dc254b3",
  token_type: "bearer",
  expires_in: 28789,
  refresh_token: "4259114daa99d557684ea607d568fe057e946621854f6d742115499c8b1cb809",
  created_at: 1539046277,
  last_sign_in: null
}`}
</code></pre>
      </div>
      <h3 className="subtitle">API Host</h3>
      <p><strong>Production:</strong> <code>https://api.ccihub.com</code></p>
      <p><strong>Staging:</strong> <code>https://staging-api.ccihub.com</code></p>
    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/api/Intro.js